import { lighten, transparentize } from "polished";
import styled, { css } from "styled-components";

import SpinnerLoading from "@/components/SpinnerLoading";

export const ButtonSpinnerLoading = styled(SpinnerLoading)`
  position: absolute;
  border-color: ${({ theme }) => transparentize(0.6, theme.text)};
  border-left-color: ${({ theme }) => theme.text};
`;

interface ButtonContainerAttrs {
  isLoading?: boolean;
}

export const ButtonContainer = styled.button<ButtonContainerAttrs>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme, isLoading }) => (isLoading ? "transparent" : theme.text)};
  background-color: ${({ theme }) => theme.primary};
  transition: color 0.3s ease, background-color 0.3s ease;
  cursor: pointer;

  &:focus-visible {
    box-shadow: 0 0 0 2px ${({ theme }) => lighten(0.3, theme.primary)};
  }

  &[disabled] {
    opacity: 0.6;
    pointer-events: none;
    background-color: ${({ theme }) => theme.background_light};
  }

  ${({ isLoading }) =>
    !!isLoading &&
    css`
      pointer-events: none;
      user-select: none;

      & > *:not(${ButtonSpinnerLoading}) {
        opacity: 0 !important;
      }
    `}

  & > svg.icon {
    height: 14px;
    flex: none;
    fill: ${({ theme }) => theme.text};
  }
`;
